import PropTypes from 'prop-types';
import React from 'react';
import { SuggestedProjectsSection } from '../common/SuggestedProjectsSection.js';

export class ProjectRecommendations extends React.PureComponent {
	constructor(props, context) {
		super(props, context);
	}

	render() {
		return (
				<section className="more-projects tapestry yellow">
					<h2>Support a project today</h2>
					<SuggestedProjectsSection
							minProjectsToShow={3}
							useDefaults={true}
					/>
				</section>
		);
	}
}

ProjectRecommendations.propTypes = {
	viewingOwnPage: PropTypes.bool.isRequired
};
